import { MMButton as LibraryButton } from 'mmfintech-portal-commons'
import type { MMButtonProps } from 'mmfintech-portal-commons/types'

type ButtonVariant =
  | `primary`
  | `secondary`
  | 'alternative'
  | 'round-primary'
  | 'round-secondary'
  | 'delete'
  | 'dashboard'
  | 'search'
  | 'filter'
  | 'round-filter'
  | 'security'
  | 'security-delete'

const MMButton = ({ variant = 'primary', ...props }: MMButtonProps<ButtonVariant>) => (
  <LibraryButton variant={variant} {...props} />
)
export default MMButton
